// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2Xy7m","title":"ClientInsurance_title__2PhN2","itemText":"ClientInsurance_itemText__1Fz6i"};